import { computed, Injectable, signal, TemplateRef } from "@angular/core";
import { ModalType } from "@core/enums/ModalType.enum";

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private message  = signal<TemplateRef<any> | null>(null);
  private type = signal<ModalType | undefined>(undefined);

  showModal = computed(() => !!this.message())
  getMessage = computed(() => this.message());
  getType = computed(() => this.type())

  open(message: TemplateRef<any> | null, type: ModalType){
    this.message.set(message);
    this.type.set(type);
  }

  close(){
    this.message.set(null);
    this.type.set(undefined);
  }
}
